module.exports = __webpack_public_path__ + "static/media/cube-alt.ae9b0e16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cube-alt.svg
// module id = 58
// module chunks = 0